import { GridColumnGroupingModel } from '@mui/x-data-grid'

export const getColumnGroupingModel = (groups: any[]): GridColumnGroupingModel => {
  if (!groups) return []

  return groups.map(({ code, headerName, background, children, headerClassName }: any) => {
    const newGroup = {
      groupId: code,
      headerName,
      background,
      children: children.map((field: string) => ({ field })),
      headerClassName,
      freeReordering: true,
    }

    return newGroup
  })
}
